<template>
  <div class="nav-main">
    <div class="row">
      <div
        class="col"
        v-for="item in kpiItem"
        :key="item.id"
        @click="goPage(item)"
        :class="{ 'has-clock-col': item.hasClock }"
      >
        <h4>
          <span v-if="item.name !== 'SWIP'">{{ item.name }}</span>
          <span v-if="item.name === 'SWIP'">WIP</span>
          <span
            class="p-l-2"
            v-if="
              (item.type == null && item.expected != -1) ||
              item.type == 'countDown'
            "
          >
            {{ item.expected }}
          </span>
          <span class="p-l-2" v-if="item.type == 'per' && item.name === 'FPY'">
            <span v-show="item.expected !== 0">{{ item.expected * 100 }}%</span>
            <span v-show="item.expected === 0">N/A</span>
          </span>
          <span class="p-l-2" v-if="item.type == 'per' && item.name !== 'FPY'">
            {{ item.expected * 100 }}%
          </span>
        </h4>
        <div class="s-row">
          <div class="s-col">
            <span class="font-big" v-if="item.type == null">
              {{ item.achieved }}
            </span>
            <span
              class="font-big"
              v-if="item.type == 'per' && item.name !== 'FPY'"
            >
              {{ achieved(item.achieved) }}
            </span>
            <span
              class="font-big"
              v-if="item.type == 'per' && item.name === 'FPY'"
            >
              <span v-show="item.expected !== 0">
                {{ achieved(item.achieved) }}
              </span>
              <span v-show="item.expected === 0">N/A</span>
            </span>
            <span class="font-big" v-if="item.type === 'countDown'">
              {{ item.achieved }}
            </span>
            <span class="font-small" v-if="item.unit != undefined">
              {{ item.unit }}
            </span>
          </div>
        </div>
        <div class="clock-area" v-if="item.hasClock">
          <clock-chart
            :current-time="currentTime"
            :colors="colors"
          ></clock-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ClockChart from '@/components/clock-chart'

  export default {
    components: {
      ClockChart,
    },
    inject: ['getCurrentPage', 'getUiid'],
    props: {
      kpiItem: {
        type: Array,
        default() {
          return []
        },
      },
      currentTime: {
        type: Number,
        default: 0,
      },
      colors: {
        type: Array,
        default() {
          return []
        },
      },
    },
    data() {
      return {}
    },
    computed: {
      currentPage() {
        return this.getCurrentPage()
      },
      uiid() {
        return this.getUiid()
      },
    },
    methods: {
      achieved(item) {
        return parseFloat((item * 100).toPrecision(2)) + '%'
      },
      goPage(item) {
        switch (item.name) {
          case 'TT':
            this.$router.push({
              path: '/ttChart',
              query: {
                id: this.currentPage,
                uiid: this.uiid,
              },
            })
            break
          case 'Completion':
            this.$router.push({
              path: '/not-completed-job-list',
              query: {
                id: this.currentPage,
                uiid: this.uiid,
              },
            })
            break
          case 'SWIP':
            this.$router.push({
              path: '/swip-list',
              query: {
                id: this.currentPage,
                uiid: this.uiid,
              },
            })
            break
          case 'SCOT':
            this.$router.push({
              path: '/not-on-time-job-list',
              query: {
                id: this.currentPage,
                uiid: this.uiid,
              },
            })
            break
          case 'FPY':
            this.$router.push({
              path: '/nc-job-list',
              query: {
                id: this.currentPage,
                uiid: this.uiid,
              },
            })
            break
          case 'Utilization':
            this.$router.push({
              path: '/lost-hour-region',
              query: {
                id: this.currentPage,
                uiid: this.uiid,
              },
            })
            break
          case 'Lost Hour':
            this.$router.push({
              path: '/lost-hour-list',
              query: {
                id: this.currentPage,
                uiid: this.uiid,
              },
            })

            break
          default:
            break
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .nav-main {
    background: @subMaster;
    color: @white6;
    min-height: 109px;
    h4 {
      color: @white6;
      font-weight: 600;
      padding-bottom: 15px;
      font-size: 22px;
      margin: 0;
      text-align: center;
      &.text-left {
        text-align: left;
      }
    }
    .row {
      padding: 0;
      display: flex;
      width: 100%;
      .col {
        border-right: 1px solid @white2;
        padding: 10px 0;
        position: relative;
        box-shadow: 1px 0 0 @black1;
        flex: 1;
        cursor: pointer;
        &:hover,
        &:active {
          box-shadow: 0 0 10px inset #4378c3;
        }
        &:last-child {
          border: none;
        }
        &.clock-area {
          flex: 0 0 110px;
        }
      }
      .has-clock-col {
        flex: 0 0 260px;
        padding-right: 100px;
        position: relative;
        .clock-area {
          position: absolute;
          right: 0;
          top: 20px;
        }
      }
    }

    .s-row {
      display: -webkit-flex;
      display: flex;
      text-align: center;
      .s-col {
        flex: 1;
        line-height: 1;
        span {
          display: inline-block;
          padding: 0 2px;
          &.font-small {
            padding-top: 24px;
            font-size: 20px;
          }
        }
      }

      .text-right {
        line-height: 1;
        .tc {
          text-align: center;
          padding-top: 5px;
        }
      }
      .font-big,
      .font-big-m {
        color: @white;
        font-weight: 600;
      }
      .font-big.weaken {
        color: inherit;
      }
    }
  }
  .p-l-2 {
    padding-left: 20px;
  }
  .font-big {
    font-size: 48px;
  }
</style>
